import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.vitrolink'),
    id: 'vitrolink',
    sidebar: [
        {
            id: 'interoperability',
            label: i18n.t('configuration.sections.interoperability'),
            icon: 'far fa-phone-laptop',
            routeName: 'Interoperability',
            hasChildren: false
        },
        {
            id: 'assignment',
            label: i18n.tc('configuration.sections.assignments.title', 2),
            icon: 'far fa-repeat',
            routeName: 'AssayAssignment',
            hasChildren: true,
            active: true,
            children: [
                // TODO: Next routeName must be modified when Front Development, all sections use the same components but change the title
                {
                    id: 'assayAssignment',
                    label: i18n.t('configuration.sections.assignments.assays'),
                    routeName: 'AssayAssignment'
                },
                {
                    id: 'sampleTypeAssignment',
                    label: i18n.t('configuration.sections.assignments.sampleTypes'),
                    routeName: 'SampleTypeAssignment'
                },
                {
                    id: 'locationAssignment',
                    label: i18n.t('configuration.sections.assignments.locations'),
                    routeName: 'LocationAssignment'
                },
                {
                    id: 'procedureAssignment',
                    label: i18n.t('configuration.sections.assignments.procedures'),
                    routeName: 'ProcedureAssignment'
                },
                {
                    id: 'provinceAssignment',
                    label: i18n.t('configuration.sections.assignments.provinces'),
                    routeName: 'ProvinceAssignment'
                },
                {
                    id: 'municipalityAssignment',
                    label: i18n.t('configuration.sections.assignments.municipalities'),
                    routeName: 'MunicipalityAssignment'
                },
                {
                    id: 'countryAssignment',
                    label: i18n.t('configuration.sections.assignments.countries'),
                    routeName: 'CountryAssignment'
                },
                {
                    id: 'genderAssignment',
                    label: i18n.t('configuration.sections.assignments.gender'),
                    routeName: 'GenderAssignment'
                }
            ]
        }
    ]
}
